import { set as idbSet } from 'idb-keyval';
import * as Sentry from '@sentry/react';

export const set = async (idbKey, value) => {
  try {
    await idbSet(idbKey, value);
  } catch (error) {
    if (error?.name === 'InvalidStateError') {
      // Wait for a short while so that idb-keyval can open a new connection
      await new Promise((resolve) => setTimeout(resolve, 50));
      try {
        await idbSet(idbKey, value);
        return;
      } catch (err) {
    Sentry.captureException(err, {
      extra: { idbKey },
    });
        console.error(`Retry failed to set to ${idbKey}`, { err });
        return;
      }
    }

    Sentry.captureException(error, {
      extra: { idbKey },
  });
    console.error(`Could not set to ${idbKey}`, { error });
  }
};
